import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import "../../invite.css";

const RejectRedymadeStagePage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  const projectVendorPaymentStructureId = new URLSearchParams(
    window.location.search
  ).get("sid");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password || !projectVendorPaymentStructureId) {
      alert("Please fill in all fields and make sure the URL has sid.");
      return;
    }

    setSubmitted(true);
    setLoading(true);

    try { 
      const response = await fetch(
        `${BASE_URL}/PMCWorkStageStructure/ProjectStageChangeRejectNewByMail`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            projectVendorPaymentStructureID: projectVendorPaymentStructureId,
            userName: username,
            password: password,
          }),
        }
      );
      setSuccess(response.ok);
    } catch (error) {
      console.error("Error:", error);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  if (!submitted) {
    return (
      <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
        <div className="card-box">
          <h2 className="card-title">Login </h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input-field"
              required
            />
            <br />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
              required
            />
            <br />
            <button type="submit" className="submit-btn">
             Continue
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="center-screen">
        <p>Rejecting stage, please wait...</p>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon">
              <FaCheck size={48} color="#a0b750" />
            </div>
            <h2 className="card-title">Rejected</h2>
            <p className="card-msg">Stage has been Rejected.</p>
          </>
        ) : (
          <>
            <div className="icon">
              <FaCheck size={48} color="#888" />
            </div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">Unable to Reject stage.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default RejectRedymadeStagePage;
